import { render, staticRenderFns } from "./SupportIndex.vue?vue&type=template&id=23d5f348&"
import script from "./SupportIndex.vue?vue&type=script&lang=js&"
export * from "./SupportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports